export function getNotInOrderRouteId(routeId: string) {
  return `${routeId}-notInOrder`
}
